import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import DataWaybillComponent from '../../../components/Content/Complaint/DataWaybillComponent';
import * as ActionComplaint from '../../../core/action/Complaint/ActionComplaint';

interface IProps {
    getDetailDocument: any;
    getComplaintProcess: any;
    getIdComplaint: any;
    isLoading: boolean;
    actionComplaint: any;
}

class DataWaybillContainer extends Component<IProps> {
  render() {
    return (
      <React.Fragment>
        <DataWaybillComponent
            getDetailDocument={this.props.getDetailDocument}
            getComplaintProcess={this.props.getComplaintProcess}
            getIdComplaint={this.props.getIdComplaint}
            isLoading={this.props.isLoading}
            handleDownload={this.props.actionComplaint.downloadInvestigasiPdf}
        />
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state: any) => ({
    getComplaintProcess: state.Complaint.propertiesComplaint.complaintProcessType,
    getIdComplaint: state.Complaint.detailComplaint.idComplaint,
    isLoading: state.Toggle.isLoading,
});
const mapDispatchToProps = (dispatch: any) => ({
  actionComplaint: bindActionCreators(ActionComplaint, dispatch),
});
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(DataWaybillContainer);